import { render, staticRenderFns } from "./PageEditor.vue?vue&type=template&id=4cd4d332&"
import script from "./PageEditor.vue?vue&type=script&lang=ts&"
export * from "./PageEditor.vue?vue&type=script&lang=ts&"
import style0 from "./PageEditor.vue?vue&type=style&index=0&id=4cd4d332&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports